module.exports = __webpack_public_path__ + "img/windows_fqa_login.33249635.png";